import { render, staticRenderFns } from "./CasesYearChart.vue?vue&type=template&id=28ed660b"
import script from "./CasesYearChart.vue?vue&type=script&lang=js"
export * from "./CasesYearChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports